<template>
  <div>
    <div class="mt-15 container card_container">
      <div class="mb-5 titolo">
        <h3 class="text-white mt-5 text-center"><i class="fas fa-clock"></i> Storico Pagamenti</h3>
      </div>
      <b-container class="bv-example-row">
        <b-card bg-variant="light">
          <b-container class="bv-example-row pt-lg-6"
            ><b-row>
              <b-col sm class="mb-7">
                <span class="text-primary">Codice fiscale</span><br />
                <span>{{ assistito.codiceFiscale }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Assistito</span><br />
                <span>{{ assistito.nome }} {{ assistito.cognome }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Data di nascita</span><br />
                <span>{{ assistito.dataNascita }}</span>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-container>
    </div>

    <div v-if="jsonData.storico != null && jsonData.storico.length > 0">
      <div v-for="item in jsonData.storico" :key="item.idTransazione">
        <div class="mt-5 container card_container mb-5">
          <b-card bg-variant="light" class="mb-5">
            <b-container class="bv-example-row pt-lg-6">
              <b-row>
                <b-col sm class="mb-7">
                  <span class="text-primary">Struttura</span><br />
                  <span>ASREM</span>
                </b-col>
                <b-col sm class="mb-7">
                  <span class="text-primary">Emissione Ricetta</span><br />
                  <span>{{ item.dataEmissioneRicetta }}</span>
                </b-col>
                <b-col sm class="mb-7">
                  <span v-if="item.nre.match(/^\d{4}A\d{10}$/g) != null" class="text-primary">Codice impegnativa</span>
                  <span v-else class="text-primary">Tipo Erogazione</span>
                  <br />
                  <span>{{ item.nre }}</span>
                </b-col>
              </b-row>
            </b-container>
          </b-card>
          <div>
            <b-button class="mx-2 mb-2 btn btn-primary" @click="onScarica(item)" v-b-modal.pdfmodel><i class="fas fa-file-download fs-2x"></i> Ricevuta</b-button>
          </div>
          <div class="my-5">
            <datatable-storico-pagamenti :appuntamenti="item.appuntamenti" :idModal="item.idPrenotazione"></datatable-storico-pagamenti>
          </div>
          <b-card bg-variant="light" class="border-footer-card">
            <b-container class="bv-example-row">
              <b-row class="pt-lg-6">
                <b-col sm class="mb-7">
                  <span class="text-primary">Priorità:</span><span style="margin-left: 10px">{{ item.classePriorita }}</span>
                </b-col>
                <b-col sm class="mb-7">
                  <span class="text-primary">Tipo esenzione:</span>
                  <span style="margin-left: 10px">N/D</span>
                </b-col>
                <b-col sm class="mb-7">
                  <span class="text-primary">Importo:</span>
                  <span style="margin-left: 10px">{{ item.importo }}</span>
                </b-col>
              </b-row>
            </b-container>
          </b-card>
        </div>
      </div>
    </div>
    <div v-else-if="jsonData.storico != null && jsonData.storico.length === 0">
      <div class="mt-5 container card_container mb-5">
        <b-card bg-variant="light" class="mb-5">
          <b-container class="bv-example-row pt-lg-6">
            <b-row class="text-center">
              <b-col sm class="mb-7">
                <strong><span style="margin-left: 10px" class="text-center">Nessuno storico pagamenti</span></strong>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
    <pdf-viewer :pdf="jsonData.pdf" :title="title"></pdf-viewer>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import pdfViewer from "../pdfViewer/pdfViewer.vue";
import datatableStoricoPagamenti from "../datatable/datatableStoricoPagamenti.vue";
import AuthService from "@/services/authService";
import EngiService from "@/services/engiService";
export default {
  components: { pdfViewer, Loading, datatableStoricoPagamenti },
  data() {
    return {
      pathResourceInfoUtente: "/api/v2.0/appecupt/auth/prelevaAnagraficaUtente",
      pathResourceStoricoPagamenti: "/api/v2.0/appecupt/aslengi/listaPagati",
      pathResourceScarica: "/api/v2.0/appecupt/aslengi/stampaRicevutaPagamento",
      tokenLogin: null,
      jsonData: {
        storico: [],
        pdf: "",
      },
      assistito: {},
      isLoading: false,
      title: "Fattura",
    };
  },
  mounted: function () {
    let me = this;
    me.tokenLogin = sessionStorage.getItem("loginData");
    me.loadInfoUtente();
    me.loadStorico();
  },
  methods: {
    async loadInfoUtente() {
      let me = this;
      try {
        const responseInfoUtente = await AuthService.anagraficaUtente(me.tokenLogin);
        me.assistito = responseInfoUtente.data.data;
      } catch (error) {
        me.$bvModal
          .msgBoxOk(error, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
    async loadStorico() {
      let me = this;
      me.isLoading = true;
      try {
        const responseStoricoPagamenti = await EngiService.storicoPagamenti();
        if (responseStoricoPagamenti.data.stato === 200) {
          me.jsonData.storico = responseStoricoPagamenti.data.data;
          me.isLoading = false;
        } else {
          me.$bvModal
            .msgBoxOk("Errore scaricamento ricevuta", {
              title: "Errore Caricamento",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch(() => {});
        }
      } catch (e) {
        me.isLoading = false;
        me.$bvModal
          .msgBoxOk(e, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
    async onScarica(item) {
      let me = this;
      me.isLoading = true;
      try {
        const parametriScaricaAvviso = {
          idTransazione: item.idTransazione,
        };
        const responseScaricaAvviso = await EngiService.stampaRicevutaPagamento(parametriScaricaAvviso);
        me.jsonData.pdf = responseScaricaAvviso.data.data;
        me.isLoading = false;
      } catch (e) {
        me.isLoading = false;
        me.$bvModal
          .msgBoxOk(e, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
};
</script>
